import { ApplicationPaneHeader } from './../../atoms/applications/ApplicationPaneHeader';
import * as React from 'react';
import { observer, inject } from 'mobx-react';
import './confirmationPane.module.scss';
import { Pane, PaneBody, PaneBackButton, Page } from '../../atoms/applications/page';
import { Loader } from '../../atoms/forms/loader';
import { ButtonWrapper, SubmitButton } from '../../atoms/forms/vertical/base';
import { observable, makeObservable } from 'mobx';
import {
  SummaryBody,
  SummaryHeader,
  SummaryStartDateRow,
  SummaryTotalPriceRow,
} from '../../molecules/applications/base';
import { CardSummary } from '../../molecules/payment/CardInput';
import { EntranceFeeSummary } from '../../molecules/applications/EntranceFeeSummary';
import { MembershipItemDetailedSummary } from '../../molecules/applications/MembershipItemDetailedSummary';
import { ApplicationErrorSummary } from '../../molecules/applications/ApplicationErrorSummary';
import { MulticreatorApplicationPageState } from '../../../containers/application/states/MulticreatorApplicationPageState';
import { ApiError } from '../../../../commonv3/api/protocol';
import { V3Routes } from '../../../routes';
import { Link } from 'react-router-dom';
import { ServiceAgreementPaneSwitch } from './ApplicationPageConfirmationPane';

const ErrorSummary = ({ errorType }) => {
  switch (errorType) {
    case 'reservation':
      return (
        <ApplicationErrorSummary title="お申し込みを確定することができませんでした。" type="normal">
          選択中のプランは満席のため、ご予約ができませんでした。お手数ですが、
          <Link id="reservation-error-retry-link" to={V3Routes.multicreatorApplicationStartDateSelect()}>
            こちら
          </Link>
          から受講開始日を設定し、パッケージを選び直してください。
        </ApplicationErrorSummary>
      );
    default:
      return (
        <ApplicationErrorSummary title="お申し込みを確定することができませんでした。" type="normal">
          考えられる要因
          <br />
          ・クレジットカードの限度額
          <br />
          ・引き落とし先の銀行口座の残高不足
          <br />
          など
        </ApplicationErrorSummary>
      );
  }
};

type Props = {
  applicationState: MulticreatorApplicationPageState;
};

export const MulticreatorConfirmationPane = inject('applicationState')(
  observer(
    class MulticreatorConfirmationPane extends React.Component<Props> {
      agreed = false;

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          agreed: observable,
        });
      }

      onCheck(checked: boolean) {
        this.agreed = checked;
      }

      render() {
        const {
          applicationState: {
            canGoBack,
            applicationPage,
            applicationPageResource,
            entranceInstallments,
            serviceAgreementState,
            cardState,
            submit,
            totalPrice,
            error,
            name,
            entranceFeeItemName,
            startDate,
            submitState: { submitting },
          },
        } = this.props;
        if (applicationPageResource.loading) {
          return <Loader />;
        }

        const showNewAgreement = !!serviceAgreementState.serviceAgreement;
        const allAgreed = showNewAgreement ? serviceAgreementState.isAllAgreed : this.agreed;
        const isReservationError =
          error &&
          error instanceof ApiError &&
          error.isOperationalError() &&
          error.body.startsWith('[RESERVATION_ERROR]');
        return (
          <Page>
            <Pane>
              <PaneBody>
                {canGoBack && <PaneBackButton />}
                <ApplicationPaneHeader plan={name} />
                {applicationPage.membership_item.price > 0 && (
                  <>
                    <SummaryHeader>プラン内容</SummaryHeader>
                    <MembershipItemDetailedSummary item={applicationPage.membership_item} />
                  </>
                )}
                {applicationPage.entrance_fee_item && (
                  <EntranceFeeSummary
                    title={entranceFeeItemName}
                    entranceFee={applicationPage.entrance_fee_item}
                    installments={entranceInstallments}
                  />
                )}
                <SummaryHeader>お支払い方法</SummaryHeader>
                <SummaryBody>
                  <CardSummary styleName="card-summary" card={cardState.card} />
                </SummaryBody>
                <SummaryTotalPriceRow label="お支払い金額" price={totalPrice} unit={'円（税込）'} />
                <SummaryStartDateRow startDate={startDate} textSize="s" />
                <ServiceAgreementPaneSwitch
                  serviceAgreementState={serviceAgreementState}
                  agreedOfLegacy={this.agreed}
                  onCheckOfLegacy={() => this.onCheck(!this.agreed)}
                />
                {error && <ErrorSummary errorType={isReservationError ? 'reservation' : 'other'} />}
                <ButtonWrapper>
                  <SubmitButton id="application-submit" loading={submitting} disabled={!allAgreed} onClick={submit}>
                    お申し込みを確定する
                  </SubmitButton>
                </ButtonWrapper>
              </PaneBody>
            </Pane>
          </Page>
        );
      }
    }
  )
);
